import { Component, OnInit, Input } from '@angular/core';
import { MediaBankHelperService } from '@fi-shared/media-bank/media-bank-helper.service';

const kiloByte = 1024,
    megaByte = 1024 * kiloByte,
    gigaByte = 1024 * megaByte;

@Component({
    selector: 'fi-file-size',
    template: '{{getFileSizeText()}}',
    standalone: false,
})
export class FileSizeComponent implements OnInit {
    @Input() fileSize: any;

    constructor(private mediaBankHelperService: MediaBankHelperService) {}

    ngOnInit() {}

    getFileSizeText() {
        return this.mediaBankHelperService.getFileSizeText(this.fileSize);
    }
}
